import { useState } from "react"
import {
  Flex,
  Text,
  Heading,
  Accordion,
  AccordionItem,
  AccordionButton,
  Box,
  AccordionIcon,
  AccordionPanel,
  Image,
  UnorderedList,
  ListItem,
  Collapse,
  Button,
  SimpleGrid,
} from "@chakra-ui/react"
import Document from "./Document"

const documente = [
  {
    text: "Nota de informare GDPR Groupama",
    url:
      "https://www.cezinfo.ro/wp-content/uploads/2021/01/Anexa-2-Nota-de-informare_GDPR_Groupama.pdf",
  },
  {
    text: "CG Asigurare de viata si somaj",
    url:
      "https://www.cezinfo.ro/wp-content/uploads/2021/01/CG-Asigurare-de-viata-si-somaj.pdf",
  },
  {
    text: "Document de informare privind asigurarea de viata si somaj",
    url:
      "https://www.cezinfo.ro/wp-content/uploads/2021/01/Document-de-informare-privind-asigurarea-de-viata-si-somaj.pdf",
  },
]

const ViataSiSomaj = () => {
  const [expandedContent, setExpandedContent] = useState(false)
  const [hideButtonText, setHideButtonText] = useState("Afiseaza informatii")

  const handleHiddenContent = () => {
    if (expandedContent === true) {
      setExpandedContent(false)
      setHideButtonText("Afiseaza informatii")
    } else {
      setExpandedContent(true)
      setHideButtonText("Mai putine informatii")
    }
  }

  return (
    <Flex flexDirection="column" width="100%">
      <Flex flexDirection="column" alignItems="flex-start" width="100%">
        {/** Riscuri */}
        <Flex
          flexDirection="column"
          width="100%"
          alignItems={["center", "center", "center", "flex-start"]}
        >
          <Heading as="h5" size="sm">
            Serviciu complementar furnizarii de energie electrica oferit prin
            asigurarea
            <span style={{ color: "#006e58" }}> Groupama Asigurari</span>.
          </Heading>
          <Heading as="h4" size="sm" marginBottom="8px" marginTop="16px">
            Beneficii
          </Heading>
          <Flex
            flexDirection="row"
            alignItems="center"
            marginTop="8px"
            marginBottom="8px"
          >
            <Image
              marginRight="16px"
              src="/cez-confort-asigurat/assets/benefit.png"
              width="24px"
              height="24px"
            />
            <Text fontSize="xs" textAlign="left">
              <strong>
                Singurul furnizor de energie ce include riscul de imbolnavire cu
                virusul Sars-CoV-2 in produsele sale;
              </strong>
            </Text>
          </Flex>
          <Flex
            flexDirection="row"
            alignItems="center"
            marginTop="8px"
            marginBottom="8px"
          >
            <Image
              marginRight="16px"
              src="/cez-confort-asigurat/assets/benefit.png"
              width="24px"
              height="24px"
            />
            <Text fontSize="xs" textAlign="left">
              Siguranta unui suport financiar{" "}
              <strong>
                pentru plata a pana la 6 facturi (suma fixa de 150 de
                lei/factura)
              </strong>{" "}
              de energie electrica in eventualitatea riscului de imbolnavire cu
              virusul SARS-CoV-2, pierderea involuntara a locului de munca sau
              accident;
            </Text>
          </Flex>

          <Flex
            flexDirection="row"
            alignItems="center"
            marginTop="8px"
            marginBottom="8px"
          >
            <Image
              marginRight="16px"
              src="/cez-confort-asigurat/assets/benefit.png"
              width="24px"
              height="24px"
            />
            <Text fontSize="xs" textAlign="left">
              <strong>Rapiditate</strong> si <strong>suport specializat</strong>{" "}
              pentru intocmirea actelor necesare platii indemnizatiei;
            </Text>
          </Flex>
          <Flex
            flexDirection="row"
            alignItems="center"
            marginTop="8px"
            marginBottom="8px"
          >
            <Image
              marginRight="16px"
              src="/cez-confort-asigurat/assets/benefit.png"
              width="24px"
              height="24px"
            />
            <Text fontSize="xs" textAlign="left">
              <strong>Simplitate</strong> la solicitarea despagubirii -{" "}
              <strong>fara cozi</strong>, <strong>fara printuri</strong>
            </Text>
          </Flex>

          <Flex
            flexDirection="row"
            alignItems="center"
            marginTop="8px"
            marginBottom="8px"
          >
            <Image
              marginRight="16px"
              src="/cez-confort-asigurat/assets/benefit.png"
              width="24px"
              height="24px"
            />
            <Text fontSize="xs" textAlign="left">
              Suport dedicat la: <strong>0725 351 413/0726 384 218</strong>, in
              zilele de Luni-Vineri, in intervalul orar:{" "}
              <strong>09:00 - 17:00</strong>;
            </Text>
          </Flex>
        </Flex>
        {/** Sfarsit riscuri */}
        <Flex flexDirection="column" width="100">
          <Heading
            as="h4"
            size="sm"
            marginTop="8px"
            textAlign={["center", "center", "center", "left"]}
          >
            Criterii eligibilitate
          </Heading>
          <Collapse in={expandedContent} width="100%">
            <Text
              marginTop="16px"
              textAlign={["center", "center", "center", "left"]}
            >
              Persoana fizica, titular al unui contract activ pentru furnizarea
              energiei electrice cu tarif <strong>CEZ Confort Asigurat</strong>{" "}
              sau <strong>CEZ Confort Asigurat Plus</strong>.
            </Text>
            <Text
              marginTop="8px"
              textAlign={["center", "center", "center", "left"]}
            >
              Intervalul de varsta sa fie intre 18 si 65 de ani (pentru
              riscurile asigurate mentionate la punctele 1 si 5) si/sau 18 si 70
              de ani (pentru riscurile asigurate mentionate la punctele 2,3 si
              4).
            </Text>
            <Flex
              width="100%"
              justifyContent={["center", "center", "center", "left"]}
            >
              <Heading as="h5" size="sm" marginTop="16px" marginBottom="16px">
                Riscuri
              </Heading>
            </Flex>
            <Accordion allowToggle width="100%">
              <AccordionItem>
                <AccordionButton>
                  <Box flex="1" textAlign="left">
                    1. Pierderea locului de munca
                  </Box>
                  <AccordionIcon />
                </AccordionButton>
                <AccordionPanel pb={4}>
                  <Text fontWeight="bold" textAlign="left" marginBottom="8px">
                    Conditii
                  </Text>
                  <UnorderedList textAlign="left" fontSize="sm">
                    <ListItem>Maxim 6 luni/an si 1 eveniment/an;</ListItem>
                    <ListItem>
                      Indemnizatia de asigurare timp de 6 luni consecutive se
                      acorda in conditiile in care asiguratul face dovada
                      (lunar) continuitatii calitatii de somer timp de 6 luni;
                    </ListItem>
                    <ListItem>
                      Perioada de asteptare: 2 luni de la data intrarii in
                      vigoare a contractului (la reinnoire nu se mai aplica
                      perioada de asteptare pentru asiguratii inrolati deja);
                    </ListItem>
                    <ListItem>Limita de varsta: 65 de ani;</ListItem>
                  </UnorderedList>
                </AccordionPanel>
              </AccordionItem>
              <AccordionItem>
                <AccordionButton>
                  <Box flex="1" textAlign="left">
                    2. Spitalizare ca urmare a unui accident si ca urmare a
                    imbolnavirii cu virusul Sars-CoV-2
                  </Box>
                  <AccordionIcon />
                </AccordionButton>
                <AccordionPanel pb={4}>
                  <Text fontWeight="bold" textAlign="left" marginBottom="8px">
                    Conditii
                  </Text>
                  <UnorderedList textAlign="left" fontSize="sm">
                    <ListItem>Maxim 6 luni/an;</ListItem>
                    <ListItem>
                      Indemnizatie platita pentru luna aferenta incheierii
                      perioadei de spitalizare;
                    </ListItem>
                    <ListItem>Numar minim zile spitalizare: 10 zile;</ListItem>
                    <ListItem>
                      Indemnizatia de asigurare se plateste dupa o spitalizare
                      continua de cel putin 10 zile;
                    </ListItem>
                    <ListItem>Limita de varsta: 70 de ani;</ListItem>
                  </UnorderedList>
                </AccordionPanel>
              </AccordionItem>
              <AccordionItem>
                <AccordionButton>
                  <Box flex="1" textAlign="left">
                    3. Incapacitate de munca in urma imbolnavirii cu virusul
                    Sars-CoV-2
                  </Box>
                  <AccordionIcon />
                </AccordionButton>
                <AccordionPanel pb={4}>
                  <Text fontWeight="bold" textAlign="left" marginBottom="8px">
                    Conditii
                  </Text>
                  <UnorderedList textAlign="left" fontSize="sm">
                    <ListItem>
                      Indemnizatia platita pentru luna aferenta incheierii
                      perioadei de incapacitate, in conditiile in care
                      Asiguratul face dovada incapacitatii de munca cu
                      diagnostic COVID-19;
                    </ListItem>
                    <ListItem>
                      Indemnizatia de asigurare se va plati la prezentarea
                      concediului medical eliberat de catre medicul de familie,
                      cu diagnosticul COVID-19, daca diagnosticarea a fost
                      facuta pe perioada de asigurare sub respectarea cerintelor
                      legislative in vigoare;
                    </ListItem>
                    <ListItem>Limita de varsta: 70 de ani;</ListItem>
                  </UnorderedList>
                </AccordionPanel>
              </AccordionItem>
              <AccordionItem>
                <AccordionButton>
                  <Box flex="1" textAlign="left">
                    4. Invaliditate permanenta totala din accident
                  </Box>
                  <AccordionIcon />
                </AccordionButton>
                <AccordionPanel pb={4}>
                  <Text fontWeight="bold" textAlign="left" marginBottom="8px">
                    Conditii
                  </Text>
                  <UnorderedList textAlign="left" fontSize="sm">
                    <ListItem>Maxim 6 luni/an;</ListItem>
                    <ListItem>Fara perioada de asteptare;</ListItem>
                    <ListItem>Limita de varsta: 70 de ani;</ListItem>
                  </UnorderedList>
                </AccordionPanel>
              </AccordionItem>
              <AccordionItem>
                <AccordionButton>
                  <Box flex="1" textAlign="left">
                    5. Incapacitate temporara din accident
                  </Box>
                  <AccordionIcon />
                </AccordionButton>
                <AccordionPanel pb={4}>
                  <Text fontWeight="bold" textAlign="left" marginBottom="8px">
                    Conditii
                  </Text>
                  <UnorderedList textAlign="left" fontSize="sm">
                    <ListItem>Maxim 6 luni/an;</ListItem>
                    <ListItem>
                      Perioada de asteptare: 60 de zile neintrerupte de
                      incapacitate. Dupa aceasta perioada Asiguratul este
                      eligibil pentru incasarea indemnizatiei lunare;
                    </ListItem>
                    <ListItem>Limita de varsta: 65 de ani;</ListItem>
                  </UnorderedList>
                </AccordionPanel>
              </AccordionItem>
            </Accordion>
            <Flex
              width="100%"
              justifyContent={["center", "center", "center", "left"]}
            >
              <Heading as="h5" size="sm" marginTop="16px" marginBottom="16px">
                Conditii
              </Heading>
            </Flex>
            <Text textAlign={["center", "center", "center", "left"]}>
              - Perioada de valabilitate: 12 luni
            </Text>
            <Text
              marginTop="16px"
              textAlign={["center", "center", "center", "left"]}
            >
              - Limita despagubirii: maxim 6 luni
            </Text>
            <Text
              marginTop="16px"
              textAlign={["center", "center", "center", "left"]}
            >
              - Notificarea producerii unui risc asigurat se face la adresa de
              e-mail daune_eb@marsh.com sau documente@groupama.ro, in maximum 30
              de zile de la data confirmarii evenimentului;
            </Text>
            <Text
              marginTop="16px"
              textAlign={["center", "center", "center", "left"]}
            >
              - Suma despagubirii: suma fixa de 150 lei/luna - plata
              indemnizatiei de asigurare va fi efectuata in contul de client CEZ
              Vanzare
            </Text>
            <Heading
              as="h4"
              size="sm"
              marginTop="16px"
              textAlign={["center", "center", "center", "left"]}
            >
              Documente
            </Heading>
            <SimpleGrid minChildWidth="100px" spacing="16px" marginTop="16px">
              {documente.map((document) => (
                <Document
                  key={document.text + document.url}
                  documentText={document.text}
                  documentUrl={document.url}
                />
              ))}
            </SimpleGrid>
          </Collapse>
        </Flex>
      </Flex>
      <Flex
        justifyContent="center"
        alignItems="center"
        marginBottom={["-24px", "-24px", "-24px", "-48px"]}
        marginTop="16px"
      >
        <Button onClick={() => handleHiddenContent()}>{hideButtonText}</Button>
      </Flex>
    </Flex>
  )
}

export default ViataSiSomaj
